import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { ConfigSortableList } from '@sierralabs/core-ui';
import { useConfigComponent } from '../../hooks/component/useConfigComponent';
import { useSiteContext } from '../../SiteContext';
import SiteEventEditDialog from './SiteEventEditDialog';
export function SiteEventConfigurator({ component, eventTypes }) {
    const [events, setEvents] = useState(component.events || []);
    const { eventPlugins } = useSiteContext();
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState();
    const selectedEvent = typeof selectedIndex === 'number' ? events[selectedIndex] : undefined;
    const { insert, update, move, remove } = useConfigComponent(component);
    // update events on component change
    useEffect(() => {
        setEvents(component.events || []);
    }, [component]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ConfigSortableList, { data: events || [], renderItem: (event, index) => {
                var _a;
                const plugin = eventPlugins.find(p => p.type === event.type);
                if (!plugin)
                    return (React.createElement(Alert, { key: index, severity: 'error' },
                        "Plugin \"",
                        event.type,
                        "\" not found"));
                return (React.createElement("div", { key: index, className: 'event-detail', onClick: () => setSelectedIndex(index) }, ((_a = plugin.getConfigSummary) === null || _a === void 0 ? void 0 : _a.call(plugin, event)) || 'No configuration summary'));
            }, footer: React.createElement(Button, { size: 'small', onClick: () => {
                    setOpenDialog(true);
                    setSelectedIndex(events.length);
                } }, "Add Event"), onMove: (sourceIndex, destinationIndex) => {
                const [event] = events.splice(sourceIndex, 1);
                events.splice(destinationIndex, 0, event);
                move('events', sourceIndex, destinationIndex);
            }, onDelete: (index) => {
                // remove format component
                events.splice(index, 1);
                setEvents([...events]);
                remove(`events[${index}]`);
            } }),
        (openDialog || selectedEvent) && (React.createElement(SiteEventEditDialog, { open: true, component: component, eventConfig: selectedEvent, supportedEventTypes: eventTypes, onCancel: () => {
                setSelectedIndex(undefined);
                setOpenDialog(false);
            }, onChange: event => {
                setSelectedIndex(undefined);
                setOpenDialog(false);
                if (!selectedEvent) {
                    setEvents([...events, event]);
                }
                else if (typeof selectedIndex === 'number') {
                    events[selectedIndex] = event;
                    setEvents([...events]);
                }
                if (!Array.isArray(events)) {
                    update('events', []);
                }
                if (typeof selectedIndex === 'number') {
                    update(`events[${selectedIndex}]`, event);
                }
                else {
                    insert('events', event);
                }
            } }))));
}
export default SiteEventConfigurator;
//# sourceMappingURL=SiteEventConfigurator.js.map